<app-breadcrumb [title]="'Services'" [breadcrumb]="'services'"></app-breadcrumb>

<div class="row p-4">
  <div class="col-md-3 p-4 col-lg-4 col-xl-4" *ngFor="let service of services">
    <a>
      <div class="classic-effect">
        <img [src]="service.imageUrl" class="img" alt="blog" />
        <span></span>
      </div>
    </a>
    <div class="blog-details">
      <h4>{{ service.name }}</h4>

      <p class="text-sm" style="text-align: justify">
        {{ service.description }}
      </p>
      <hr class="style1" />
      <!-- <h6>{{ "by:" + blog.by }} , {{ "2 Comment" }}</h6> -->
    </div>
  </div>
</div>
